import EmailElement from './email-element';

export {
  EmailElement
};



// WEBPACK FOOTER //
// src/common/form-elements/email-element-folder/index.js